import { File } from '@app/models';
import { Action } from '@ngrx/store';

export interface ExportProformaDTO {
  FollowId: string;
  PortId: number;
  ProviderId: number;
  businessUnit: string;
  CountryId: number;
  ProformaId: number;
  proformaName: string;
}

export enum FileActionTypes {
  LoadByProduct = '[File] Load by product',
  LoadByProductSuccess = '[File] Load by product Success',
  LoadByProductFail = '[File] Load by product Fail',
  UpsertMany = '[File] Upsert many',
  AddOne = '[File] Add one',
  RemoveOne = '[File] Remove one',
  ExportFollow = '[File] Export follow',
  ExportFollowPending = '[File] Export follow pending',
  ExportFollowSuccess = '[File] Export follow success',
  ExportFollowFail = '[File] Export follow fail',
  ExportProforma = '[File] Export proforma',
  ExportProformaSuccess = '[File] Export proforma success',
  ExportProformaPending = '[File] Export proforma pending',
  ExportProformaFail = '[File] Export proforma fail',
  ExportProviders = '[File] Export providers',
  ExportProvidersSuccess = '[File] Export providers success',
  ExportProvidersFail = '[File] Export providers fail',
  DownloadImg = '[File] Download all img',
  DownloadImgSuccess = '[File] Download all img success',
  DownloadImgFail = '[File] Download all img fail',
  DownloadImgUpdate = '[File] Download all img update',
  GetLink = '[API] Get file link',
  GetLinkFail = '[API] Get file link fail',
  Upload = '[AWS] Upload file to AWS',
  UploadSuccess = '[AWS] Upload file to AWS success',
  UploadFail = '[AWS] Upload file to AWS fail',
  Notify = '[API] Notify file upload',
  ExportImplantation = '[File] Export implementation',
  ExportImplantationSuccess = '[File] Export implementation success',
  ExportImplantationFail = '[File] Export implementation fail',

  ExportHierarchyCountry = '[File] Export Hierarchy Country',
  ExportHierarchyCountrySuccess = '[File] Export Hierarchy Country success',
  ExportHierarchyCountryFail = '[File] Export Hierarchy Country fail',

  ExportHierarchyPlanner = '[File] Export Hierarchy Planner',
  ExportHierarchyPlannerSuccess = '[File] Export Hierarchy Planner success',
  ExportHierarchyPlannerFail = '[File] Export Hierarchy Planner fail',

  ExportHierarchyPlannerFood = '[File] Export Hierarchy Planner Food',
  ExportHierarchyPlannerFoodSuccess = '[File] Export Hierarchy Planner Food success',
  ExportHierarchyPlannerFoodFail = '[File] Export Hierarchy Planner Food fail',

  GetLinkHierarchyCountry = '[API] Get file link hierarchy country',
  GetLinkHierarchyCountrySuccess = '[API] Get file link hierarchy country success',
  GetLinkHierarchyCountryFail = '[API] Get file link hierarchy country fail',

  UploadHierarchyCountry = '[File] Upload file hierarchy country',
  UploadHierarchyCountrySuccess = '[File] Upload file hierarchy country success',
  UploadHierarchyCountryFail = '[File] Upload file hierarchy country fail',

  UploadHierarchyCountryUpdate = '[File] Upload file hierarchy country update',
  UploadHierarchyCountryUpdateSuccess = '[File] Upload file hierarchy country update success',
  UploadHierarchyCountryUpdateFail = '[File] Upload file hierarchy country update fail',

  GetLinkHierarchyPlanner = '[API] Get file link hierarchy planner',
  GetLinkHierarchyPlannerSuccess = '[API] Get file link hierarchy planner success',
  GetLinkHierarchyPlannerFail = '[API] Get file link hierarchy planner fail',

  GetLinkHierarchyPlannerFood = '[API] Get file link hierarchy planner food',
  GetLinkHierarchyPlannerFoodSuccess = '[API] Get file link hierarchy planner food success',
  GetLinkHierarchyPlannerFoodFail = '[API] Get file link hierarchy planner food fail',

  UploadHierarchyPlanner = '[File] Upload file hierarchy planner',
  UploadHierarchyPlannerSuccess = '[File] Upload file hierarchy planner success',
  UploadHierarchyPlannerFail = '[File] Upload file hierarchy planner fail',

  UploadHierarchyPlannerUpdate = '[File] Upload file hierarchy planner update',
  UploadHierarchyPlannerUpdateSuccess = '[File] Upload file hierarchy planner update success',
  UploadHierarchyPlannerUpdateFail = '[File] Upload file hierarchy planner update fail',

  UploadHierarchyPlannerFood = '[File] Upload file hierarchy planner food',
  UploadHierarchyPlannerFoodSuccess = '[File] Upload file hierarchy planner food success',
  UploadHierarchyPlannerFoodFail = '[File] Upload file hierarchy planner food fail',

  UploadHierarchyPlannerFoodUpdate = '[File] Upload file hierarchy planner food update',
  UploadHierarchyPlannerFoodUpdateSuccess = '[File] Upload file hierarchy planner food update success',
  UploadHierarchyPlannerFoodUpdateFail = '[File] Upload file hierarchy planner update food fail',

  DownloadColor = '[File] Download new color',
  DownloadColorSuccess = '[File] Download new color success',
  DownloadColorFail = '[File] Download new color fail',

  GenerateTemplate = '[File] generate template',
  GenerateTemplateSuccess = '[File] generate template success',
  GenerateTempLink = '[File] generate temp link',
  GenerateTemplateFail = '[File] generate template fail',

  DownloadRetroplanning = '[File] Download retroplanning',
  DownloadRetroplanningSucces = '[File] Download retroplanning success',
  DownloadRetroplanningFail = '[File] Download retroplanning fail',

  GetLinkRetroplanning = '[API] Get file link retroplanning',
  GetLinkRetroplanningSuccess = '[API] Get file link retroplanning success',
  GetLinkRetroplanningFail = '[API] Get file link retroplanning fail',

  UploadRetroplanning = '[File] Upload file retroplanning',
  UploadRetroplanningSuccess = '[File] Upload file retroplanning success',
  UploadRetroplanningFail = '[File] Upload file retroplanning fail',

  UploadRetroplanningUpdate = '[File] Upload file retroplanning update',
  UploadRetroplanningUpdateSuccess = '[File] Upload file retroplanning update success',
  UploadRetroplanningUpdateFail = '[File] Upload file retroplanning update fail',

  ExportGlobalOcm = '[File] export global ocm',
  ExportGlobalOcmSuccess = '[File] export global ocm success',
  ExportGlobalOcmFail = '[File] export global ocm fail',
  ExportGlobalOcmPending = '[File] export global ocm pending',
  ExportGlobalOcmComplete = '[File] export global ocm complete',

  ExportOcm = '[File] export ocm',
  ExportOcmSuccess = '[File] export ocm success',
  ExportOcmFail = '[File] export ocm fail',
  // ExportOcmPending = '[File] export ocm pending',
  // ExportOcmComplete = '[File] export ocm complete',

  ExportMasterKey = '[File] Export masterKey',
  ExportMasterKeySuccess = '[File] Export masterKey success',
  ExportMasterKeyFail = '[File] Export masterKey fail',

  DownloadQuery = '[File] Download query',
  DownloadQuerySuccess = '[File] Download query success',
  DownloadQueryFail = '[File] Download query fail',

  ExportTotalSupplier = '[File] Export total supplier',
  ExportTotalSupplierSuccess = '[File] Export total supplier success',
  ExportTotalSupplierFail = '[File] Export total supplier fail',

  UploadSingleImage = "[file] upload single image",
  UploadSingleImageSecond = "[file] upload single image second",
  UploadSingleImageSecondSuccess = "[file] upload single image second success",
  UploadSingleImageFinalized = "[file] upload single image finalized",
  UploadSingleImageSuccess = "[file] upload single image success",
  UploadSingleImageFail = "[file] upload single image fail",

  ExportMP = '[File] Export MP',
  ExportMPSuccess = '[File] Export MP success',
  ExportMPFail = '[File] Export MP fail',
  ExportMPPending = '[File] Export MP pending',

  ExportOrderSummary = '[File] Export order summary',
  ExportOrderSummaryPending = '[File] Export order summary pending',
  ExportOrderSummarySuccess = '[File] Export order summary success',
  ExportOrderSummaryFail = '[File] Export order summary fail',

  ExportFinanceSummary = '[File] Export finance summary',
  ExportFinanceSummarySuccess = '[File] Export finance summary success',
  ExportFinanceSummaryFail = '[File] Export finance summary fail',

  DownloadOrderRecap = "[Follow] download order recap",
  DownloadOrderRecapSuccess = "[Follow] download order recap success",
  DownloadOrderRecapFail = "[Follow] download order recap fail",
  DownloadOrderRecapProvider = "[Follow] download order recap provider",
  DownloadOrderRecapProviderSuccess = "[Follow] download order recap provider success",
  DownloadOrderRecapProviderFail = "[Follow] download order recap provider fail",
  DownloadPosters = "[Follow] download posters",
  DownloadPostersSuccess = "[Follow] download posters success",
  DownloadPostersFinal = "[Follow] download posters final",
  DownloadPostersFail = "[Follow] download posters fail",

}

export class LoadByProduct implements Action {
  readonly type = FileActionTypes.LoadByProduct;
  constructor(public id: number) {}
}

export class LoadByProductSuccess implements Action {
  readonly type = FileActionTypes.LoadByProductSuccess;
  constructor(public files: File[]) {}
}

export class LoadByProductFail implements Action {
  readonly type = FileActionTypes.LoadByProductFail;
  constructor(public error: any) {}
}

export class UpsertMany implements Action {
  readonly type = FileActionTypes.UpsertMany;
  constructor(public files: File[]) {}
}

export class AddOne implements Action {
  readonly type = FileActionTypes.AddOne;
  constructor(public file: File) {}
}

export class RemoveOne implements Action {
  readonly type = FileActionTypes.RemoveOne;
  constructor(public id: string) {}
}

export class DownloadImg implements Action {
  readonly type = FileActionTypes.DownloadImg;
  constructor(public followId: any) {}
}

export class DownloadImgSuccess implements Action {
  readonly type = FileActionTypes.DownloadImgSuccess;
  constructor(public data?: any) {}
}

export class DownloadImgUpdate implements Action {
  readonly type = FileActionTypes.DownloadImgUpdate;
  constructor(public data?: any) {}
}

export class DownloadImgFail implements Action {
  readonly type = FileActionTypes.DownloadImgFail;
  constructor(public error?: any) {}
}

export class ExportTotalSupplier implements Action {
  readonly type = FileActionTypes.ExportTotalSupplier;
  constructor(public part?: any){}
}

export class ExportTotalSupplierSuccess implements Action {
  readonly type = FileActionTypes.ExportTotalSupplierSuccess;
  constructor() {}
}

export class ExportTotalSupplierFail implements Action {
  readonly type = FileActionTypes.ExportTotalSupplierFail;
  constructor() {}
}

export class ExportMP implements Action {
  readonly type = FileActionTypes.ExportMP;
  constructor(public FollowId: number){}
}

export class ExportMPSuccess implements Action {
  readonly type = FileActionTypes.ExportMPSuccess;
  constructor(public data?: any) {}
}

export class ExportMPFail implements Action {
  readonly type = FileActionTypes.ExportMPFail;
  constructor(public data?: any) {}
}

export class ExportMPPending implements Action {
  readonly type = FileActionTypes.ExportMPPending;
  constructor(public any?: any) {}
}

export class ExportMasterKey implements Action {
  readonly type = FileActionTypes.ExportMasterKey;
  constructor(public name: string){}
}

export class ExportMasterKeySuccess implements Action {
  readonly type = FileActionTypes.ExportMasterKeySuccess;
  constructor() {}
}

export class ExportMasterKeyFail implements Action {
  readonly type = FileActionTypes.ExportMasterKeyFail;
  constructor() {}
}

export class DownloadQuery implements Action {
  readonly type = FileActionTypes.DownloadQuery;
  constructor(public name: string, public data?: any){}
}

export class DownloadQuerySuccess implements Action {
  readonly type = FileActionTypes.DownloadQuerySuccess;
  constructor() {}
}

export class DownloadQueryFail implements Action {
  readonly type = FileActionTypes.DownloadQueryFail;
  constructor() {}
}

export class ExportFollow implements Action {
  readonly type = FileActionTypes.ExportFollow;
  constructor(
    public id: number,
    public name: string,
    public exportType: string,
    public templateUniqId?: any,
    public filter?: string
  ) {}
}

export class ExportFollowPending implements Action {
  readonly type = FileActionTypes.ExportFollowPending;
  constructor(public data?: any) {}
}

export class ExportFollowSuccess implements Action {
  readonly type = FileActionTypes.ExportFollowSuccess;
  constructor(public data?: any) {}
}

export class ExportFollowFail implements Action {
  readonly type = FileActionTypes.ExportFollowFail;
  constructor() {}
}

export class ExportProforma implements Action {
  readonly type = FileActionTypes.ExportProforma;
  constructor(public data: any) {}
}

export class ExportProformaSuccess implements Action {
  readonly type = FileActionTypes.ExportProformaSuccess;
  constructor() {}
}

export class ExportProformaPending implements Action {
  readonly type = FileActionTypes.ExportProformaPending;
  constructor(public data?: any) {}
}

export class ExportProvidersSuccess implements Action {
  readonly type = FileActionTypes.ExportProvidersSuccess;
  constructor(public data?: any) {}
}

export class ExportProformaFail implements Action {
  readonly type = FileActionTypes.ExportProformaFail;
  constructor() {}
}

export class ExportProviders implements Action {
  readonly type = FileActionTypes.ExportProviders;
  constructor(public data: any) {}
}

// export class ExportProvidersSuccess implements Action {
//   readonly type = FileActionTypes.ExportProvidersSuccess;
//   constructor() { }
// }

export class ExportProvidersFail implements Action {
  readonly type = FileActionTypes.ExportProvidersFail;
  constructor() {}
}

export class ExportHierarchyCountry implements Action {
  readonly type = FileActionTypes.ExportHierarchyCountry;
  constructor(public data: any) {}
}

export class ExportHierarchyCountrySuccess implements Action {
  readonly type = FileActionTypes.ExportHierarchyCountrySuccess;
  constructor() {}
}

export class ExportHierarchyCountryFail implements Action {
  readonly type = FileActionTypes.ExportHierarchyCountryFail;
  constructor() {}
}

export class DownloadPosters implements Action {
  readonly type = FileActionTypes.DownloadPosters;
  constructor(public data: any) {}
}

export class DownloadPostersSuccess implements Action {
  readonly type = FileActionTypes.DownloadPostersSuccess;
  constructor() {}
}

export class DownloadPostersFinal implements Action {
  readonly type = FileActionTypes.DownloadPostersFinal;
  constructor(public data: any, public FollowId: any) {}
}

export class DownloadPostersFail implements Action {
  readonly type = FileActionTypes.DownloadPostersFail;
  constructor(public error: any) {}
}

export class ExportHierarchyPlanner implements Action {
  readonly type = FileActionTypes.ExportHierarchyPlanner;
  constructor(public data: any) {}
}

export class ExportHierarchyPlannerSuccess implements Action {
  readonly type = FileActionTypes.ExportHierarchyPlannerSuccess;
  constructor() {}
}

export class ExportHierarchyPlannerFail implements Action {
  readonly type = FileActionTypes.ExportHierarchyPlannerFail;
  constructor() {}
}

export class ExportHierarchyPlannerFood implements Action {
  readonly type = FileActionTypes.ExportHierarchyPlannerFood;
  constructor(public data: any) {}
}

export class ExportHierarchyPlannerFoodSuccess implements Action {
  readonly type = FileActionTypes.ExportHierarchyPlannerFoodSuccess;
  constructor() {}
}

export class ExportHierarchyPlannerFoodFail implements Action {
  readonly type = FileActionTypes.ExportHierarchyPlannerFoodFail;
  constructor() {}
}

export class GetLink implements Action {
  readonly type = FileActionTypes.GetLink;
  constructor(public owner: any, public file: any, public featured: boolean) {}
}

export class GetLinkFail implements Action {
  readonly type = FileActionTypes.GetLinkFail;
  constructor(public error: any) {}
}

export class Upload implements Action {
  readonly type = FileActionTypes.Upload;
  constructor(public link: string, public file: any, public followType?: any) {}
}
export class UploadSuccess implements Action {
  readonly type = FileActionTypes.UploadSuccess;
  constructor() {}
}

export class UploadFail implements Action {
  readonly type = FileActionTypes.UploadFail;
  constructor(public error: any) {}
}

export class Notify implements Action {
  readonly type = FileActionTypes.Notify;
  constructor(public id: string) {}
}

export class ExportImplantation implements Action {
  readonly type = FileActionTypes.ExportImplantation;
  constructor(public FollowId: number) {}
}

export class ExportImplantationSuccess implements Action {
  readonly type = FileActionTypes.ExportFollowSuccess;
  constructor() {}
}

export class ExportImplantationFail implements Action {
  readonly type = FileActionTypes.ExportFollowFail;
  constructor() {}
}

//Hierarchy Country
export class GetLinkHierarchyCountry implements Action {
  readonly type = FileActionTypes.GetLinkHierarchyCountry;
  constructor(public file: any) {}
}

export class GetLinkHierarchyCountrySuccess implements Action {
  readonly type = FileActionTypes.GetLinkHierarchyCountrySuccess;
  constructor(public data: any) {}
}

export class GetLinkHierarchyCountryFail implements Action {
  readonly type = FileActionTypes.GetLinkHierarchyCountryFail;
  constructor() {}
}

export class UploadHierarchyCountry implements Action {
  readonly type = FileActionTypes.UploadHierarchyCountry;
  constructor(
    public uploadUrl: string,
    public FileId: number,
    public file: any
  ) {}
}

export class UploadHierarchyCountrySuccess implements Action {
  readonly type = FileActionTypes.UploadHierarchyCountrySuccess;
  constructor(public FileId: number) {}
}

export class UploadHierarchyCountryFail implements Action {
  readonly type = FileActionTypes.UploadHierarchyCountryFail;
  constructor() {}
}

export class UploadHierarchyCountryUpdate implements Action {
  readonly type = FileActionTypes.UploadHierarchyCountryUpdate;
  constructor(public data: any) {}
}

export class UploadHierarchyCountryUpdateSuccess implements Action {
  readonly type = FileActionTypes.UploadHierarchyCountryUpdateSuccess;
  constructor() {}
}

export class UploadHierarchyCountryUpdateFail implements Action {
  readonly type = FileActionTypes.UploadHierarchyCountryUpdateFail;
  constructor() {}
}

// hierarchy planner
export class GetLinkHierarchyPlanner implements Action {
  readonly type = FileActionTypes.GetLinkHierarchyPlanner;
  constructor(public file: any) {}
}

export class GetLinkHierarchyPlannerSuccess implements Action {
  readonly type = FileActionTypes.GetLinkHierarchyPlannerSuccess;
  constructor(public data: any) {}
}

export class GetLinkHierarchyPlannerFail implements Action {
  readonly type = FileActionTypes.GetLinkHierarchyPlannerFail;
  constructor() {}
}

export class GetLinkHierarchyPlannerFood implements Action {
  readonly type = FileActionTypes.GetLinkHierarchyPlannerFood;
  constructor(public file: any) {}
}

export class GetLinkHierarchyPlannerFoodSuccess implements Action {
  readonly type = FileActionTypes.GetLinkHierarchyPlannerFoodSuccess;
  constructor(public data: any) {}
}

export class GetLinkHierarchyPlannerFoodFail implements Action {
  readonly type = FileActionTypes.GetLinkHierarchyPlannerFoodFail;
  constructor() {}
}

export class UploadHierarchyPlanner implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlanner;
  constructor(
    public uploadUrl: string,
    public FileId: number,
    public file: any
  ) {}
}

export class UploadHierarchyPlannerSuccess implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlannerSuccess;
  constructor(public FileId: number) {}
}

export class UploadHierarchyPlannerFail implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlannerFail;
  constructor() {}
}

export class UploadHierarchyPlannerUpdate implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlannerUpdate;
  constructor(public data: any) {}
}

export class UploadHierarchyPlannerUpdateSuccess implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlannerUpdateSuccess;
  constructor() {}
}

export class UploadHierarchyPlannerUpdateFail implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlannerUpdateFail;
  constructor() {}
}

export class UploadHierarchyPlannerFood implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlannerFood;
  constructor(
    public uploadUrl: string,
    public FileId: number,
    public file: any
  ) {}
}

export class UploadHierarchyPlannerFoodSuccess implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlannerFoodSuccess;
  constructor(public FileId: number) {}
}

export class UploadHierarchyPlannerFoodFail implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlannerFoodFail;
  constructor() {}
}

export class UploadHierarchyPlannerFoodUpdate implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlannerFoodUpdate;
  constructor(public data: any) {}
}

export class UploadHierarchyPlannerFoodUpdateSuccess implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlannerFoodUpdateSuccess;
  constructor() {}
}

export class UploadHierarchyPlannerFoodUpdateFail implements Action {
  readonly type = FileActionTypes.UploadHierarchyPlannerFoodUpdateFail;
  constructor() {}
}

export class DownloadColor implements Action {
  readonly type = FileActionTypes.DownloadColor;
  constructor(public FileId: any, public FollowId: any) {}
}

export class DownloadColorSuccess implements Action {
  readonly type = FileActionTypes.DownloadColorSuccess;
  constructor(public data?: any) {}
}

export class DownloadColorFail implements Action {
  readonly type = FileActionTypes.DownloadColorFail;
  constructor(public data?: any) {}
}

export class GenerateTemplate implements Action {
  readonly type = FileActionTypes.GenerateTemplate;
  constructor(public data: any) {}
}

export class GenerateTemplateSuccess implements Action {
  readonly type = FileActionTypes.GenerateTemplateSuccess;
  constructor(public data: any) {}
}

export class GenerateTempLink implements Action {
  readonly type = FileActionTypes.GenerateTempLink;
  constructor(public data: string, public fileName: string) {}
}

export class GenerateTemplateFail implements Action {
  readonly type = FileActionTypes.GenerateTemplateFail;
  constructor() {}
}

export class DownloadRetroplanning implements Action {
  readonly type = FileActionTypes.DownloadRetroplanning;
  constructor(public followId: any) {}
}

export class DownloadRetroplanningSucces implements Action {
  readonly type = FileActionTypes.DownloadRetroplanningSucces;
  constructor(public data?: any) {}
}

export class DownloadRetroplanningFail implements Action {
  readonly type = FileActionTypes.DownloadRetroplanningFail;
  constructor(public error?: any) {}
}

export class GetLinkRetroplanning implements Action {
  readonly type = FileActionTypes.GetLinkRetroplanning;
  constructor(public file: any, public followId: number) {}
}

export class GetLinkRetroplanningSuccess implements Action {
  readonly type = FileActionTypes.GetLinkRetroplanningSuccess;
  constructor(public data: any) {}
}

export class GetLinkRetroplanningFail implements Action {
  readonly type = FileActionTypes.GetLinkRetroplanningFail;
  constructor() {}
}

export class UploadRetroplanning implements Action {
  readonly type = FileActionTypes.UploadRetroplanning;
  constructor(
    public uploadUrl: string,
    public FileId: number,
    public file: any,
    public followId: number
  ) {}
}

export class UploadRetroplanningSuccess implements Action {
  readonly type = FileActionTypes.UploadRetroplanningSuccess;
  constructor(public FileId: number, public followId: number) {}
}

export class UploadRetroplanningFail implements Action {
  readonly type = FileActionTypes.UploadRetroplanningFail;
  constructor() {}
}

export class UploadRetroplanningUpdate implements Action {
  readonly type = FileActionTypes.UploadRetroplanningUpdate;
  constructor(public data: any) {}
}

export class UploadRetroplanningUpdateSuccess implements Action {
  readonly type = FileActionTypes.UploadRetroplanningUpdateSuccess;
  constructor(public followId: number) {}
}

export class UploadRetroplanningUpdateFail implements Action {
  readonly type = FileActionTypes.UploadRetroplanningUpdateFail;
  constructor() {}
}

export class ExportGlobalOcm implements Action {
  readonly type = FileActionTypes.ExportGlobalOcm;
  constructor(public data: any) {}
}

export class ExportGlobalOcmSuccess implements Action {
  readonly type = FileActionTypes.ExportGlobalOcmSuccess;
  constructor(public data?: any) {}
}

export class ExportGlobalOcmFail implements Action {
  readonly type = FileActionTypes.ExportGlobalOcmFail;
  constructor(public error?: any) {}
}

export class ExportGlobalOcmPending implements Action {
  readonly type = FileActionTypes.ExportGlobalOcmPending;
  constructor(public data?: any) {}
}

export class ExportGlobalOcmComplete implements Action {
  readonly type = FileActionTypes.ExportGlobalOcmComplete;
  constructor(public data?: any) {}
}

export class ExportOcm implements Action {
  readonly type = FileActionTypes.ExportOcm;
  constructor(public data: any) {}
}

export class ExportOcmSuccess implements Action {
  readonly type = FileActionTypes.ExportOcmSuccess;
  constructor(public data?: any) {}
}

export class ExportOcmFail implements Action {
  readonly type = FileActionTypes.ExportOcmFail;
  constructor(public error?: any) {}
}

export class ExportOrderSummary implements Action {
  readonly type = FileActionTypes.ExportOrderSummary;
  constructor(public followId: any) {}
}

export class ExportFinanceSummary implements Action {
  readonly type = FileActionTypes.ExportFinanceSummary;
  constructor(public data: any) {}
}

export class ExportFinanceSummarySuccess implements Action {
  readonly type = FileActionTypes.ExportFinanceSummarySuccess;
  constructor(public data?: any) {}
}

export class ExportFinanceSummaryFail implements Action {
  readonly type = FileActionTypes.ExportFinanceSummaryFail;
  constructor(public error?: any) {}
}

export class ExportOrderSummaryPending implements Action {
  readonly type = FileActionTypes.ExportOrderSummaryPending;
  constructor(public data: any) {}
}

export class ExportOrderSummarySuccess implements Action {
  readonly type = FileActionTypes.ExportOrderSummarySuccess;
  constructor(public data?: any) {}
}

export class ExportOrderSummaryFail implements Action {
  readonly type = FileActionTypes.ExportOrderSummaryFail;
  constructor(public error?: any) {}
}

export class UploadSingleImage implements Action {
  readonly type = FileActionTypes.UploadSingleImage;
  constructor(
    public data: any,
    public productId: number,
    public followId: number,
    public position: number
  ) { }
}

export class UploadSingleImageSuccess implements Action {
  readonly type = FileActionTypes.UploadSingleImageSuccess;
  constructor(public link: any, public file: any) { }
}


export class UploadSingleImageSecond implements Action {
  readonly type = FileActionTypes.UploadSingleImageSecond;
  constructor(public fileId: any) { }
}

export class UploadSingleImageSecondSuccess implements Action {
  readonly type = FileActionTypes.UploadSingleImageSecondSuccess;
  constructor() { }
}

export class UploadSingleImageFinalized implements Action {
  readonly type = FileActionTypes.UploadSingleImageFinalized;
  constructor() { }
}


export class UploadSingleImageFail implements Action {
  readonly type = FileActionTypes.UploadSingleImageFail;
  constructor(public error: any) { }
}

export class DownloadOrderRecap implements Action {
  readonly type = FileActionTypes.DownloadOrderRecap;
  constructor(public followId: number) {}
}

export class DownloadOrderRecapSuccess implements Action {
  readonly type = FileActionTypes.DownloadOrderRecapSuccess
  constructor(public data?: any) {}
}

export class DownloadOrderRecapFail implements Action {
  readonly type = FileActionTypes.DownloadOrderRecapFail;
  constructor(public error?: any) {}
}

export class DownloadOrderRecapProvider implements Action {
  readonly type = FileActionTypes.DownloadOrderRecapProvider;
  constructor(public followId: number) {}
}

export class DownloadOrderRecapProviderSuccess implements Action {
  readonly type = FileActionTypes.DownloadOrderRecapProviderSuccess
  constructor(public data?: any) {}
}

export class DownloadOrderRecapProviderFail implements Action {
  readonly type = FileActionTypes.DownloadOrderRecapProviderFail;
  constructor(public error?: any) {}
}

export type FileActionsUnion =
  | LoadByProduct
  | LoadByProductSuccess
  | LoadByProductFail
  | ExportFollow
  | ExportFollowPending
  | ExportFollowSuccess
  | ExportFollowFail
  | DownloadImg
  | DownloadImgSuccess
  | DownloadImgFail
  | DownloadImgUpdate
  | ExportProforma
  | ExportProformaSuccess
  | ExportProformaPending
  | ExportProformaFail
  | ExportHierarchyCountry
  | ExportHierarchyCountrySuccess
  | ExportHierarchyCountryFail
  | ExportHierarchyPlanner
  | ExportHierarchyPlannerSuccess
  | ExportHierarchyPlannerFail
  | AddOne
  | RemoveOne
  | UpsertMany
  | Upload
  | UploadFail
  | UploadSuccess
  | GetLink
  | GetLinkFail
  | Notify
  | ExportImplantation
  | ExportImplantationSuccess
  | ExportImplantationFail
  | GetLinkHierarchyCountry
  | GetLinkHierarchyCountrySuccess
  | GetLinkHierarchyCountryFail
  | UploadHierarchyCountry
  | UploadHierarchyCountrySuccess
  | UploadHierarchyCountryFail
  | UploadHierarchyCountryUpdate
  | UploadHierarchyCountryUpdateSuccess
  | UploadHierarchyCountryUpdateFail
  | GetLinkHierarchyPlanner
  | GetLinkHierarchyPlannerSuccess
  | GetLinkHierarchyPlannerFail
  | UploadHierarchyPlanner
  | UploadHierarchyPlannerSuccess
  | UploadHierarchyPlannerFail
  | UploadHierarchyPlannerUpdate
  | UploadHierarchyPlannerUpdateSuccess
  | UploadHierarchyPlannerUpdateFail
  | DownloadColor
  | DownloadColorSuccess
  | DownloadColorFail
  | GenerateTemplate
  | GenerateTemplateSuccess
  | GenerateTemplateFail
  | ExportProvidersSuccess
  | DownloadRetroplanning
  | DownloadRetroplanningSucces
  | DownloadRetroplanningFail
  | GetLinkRetroplanning
  | GetLinkRetroplanningSuccess
  | GetLinkRetroplanningFail
  | UploadRetroplanning
  | UploadRetroplanningSuccess
  | UploadRetroplanningFail
  | UploadRetroplanningUpdate
  | UploadRetroplanningUpdateSuccess
  | UploadRetroplanningUpdateFail
  | ExportHierarchyPlannerFood
  | ExportHierarchyPlannerFoodSuccess
  | ExportHierarchyPlannerFoodFail
  | GetLinkHierarchyPlannerFood
  | GetLinkHierarchyPlannerFoodSuccess
  | GetLinkHierarchyPlannerFoodFail
  | UploadHierarchyPlannerFood
  | UploadHierarchyPlannerFoodSuccess
  | UploadHierarchyPlannerFoodFail
  | UploadHierarchyPlannerFoodUpdate
  | UploadHierarchyPlannerFoodUpdateSuccess
  | UploadHierarchyPlannerFoodUpdateFail
  | ExportGlobalOcm
  | ExportGlobalOcmSuccess
  | ExportGlobalOcmFail
  | ExportGlobalOcmPending
  | ExportGlobalOcmComplete
  | ExportMasterKey
  | ExportMasterKeySuccess
  | ExportMasterKeyFail
  | DownloadQuery
  | DownloadQuerySuccess
  | DownloadQueryFail
  | ExportOcm
  | ExportOcmSuccess
  | ExportOcmFail
  | ExportTotalSupplier
  | ExportTotalSupplierSuccess
  | ExportTotalSupplierFail
  | UploadSingleImage
  | UploadSingleImageSuccess
  | UploadSingleImageSecond
  | UploadSingleImageSecondSuccess
  | UploadSingleImageFail
  | UploadSingleImageFinalized
  | GenerateTempLink
  | ExportMP
  | ExportMPSuccess
  | ExportMPFail
  | ExportMPPending
  | ExportOrderSummary
  | ExportOrderSummaryPending
  | ExportOrderSummarySuccess
  | ExportOrderSummaryFail
  | DownloadOrderRecap
  | DownloadOrderRecapSuccess
  | DownloadOrderRecapFail
  | DownloadPosters
  | DownloadPostersSuccess
  | DownloadPostersFail
  | DownloadPostersFinal
  | DownloadOrderRecapProvider
  | DownloadOrderRecapProviderSuccess
  | DownloadOrderRecapProviderFail;
